require('./../Css/style.css');

function initCookieDisclaimer() {
    var cookiePopup = $(".js-cookie-popup");
    var cookiePopupBtn = $(".js-cookie-popup-btn");

    cookiePopupBtn.on("click", function (e) {
        e.preventDefault();
        localStorage.setItem("isCookieDisclaimed", "true");
        cookiePopup.addClass("hide");
    });

    if (localStorage.getItem("isCookieDisclaimed") !== "true") {
        cookiePopup.removeClass("hide");
    }
}

export default initCookieDisclaimer;


// WEBPACK FOOTER //
// ./uPortal/Core/Shared/CookieDisclaimer/Js/index.js